import React from 'react'
import { observer } from 'mobx-react'
import { observable } from 'mobx'
import {
  FiToggleLeft as ToggleOff,
  FiToggleRight as ToggleON,
} from 'react-icons/fi'
import {
  IoMdEye as PasswordEyeIconOn,
  IoMdEyeOff as PasswordEyeIconOff,
} from 'react-icons/io'
import { i18nTranslate } from 'src/utils'
import {
  Row,
  Col,
  Button,
  Modal,
  ButtonGroup,
  Form,
  InputGroup,
} from 'react-bootstrap'
import { settingsData } from './fixture'
import { toastState, MetaDecorator } from 'src/views/components'
import { customerContainer } from 'src/models'
import './styles.scss'

@observer
class SwitchIcon extends React.Component {
  @observable switchActive = false
  @observable show = false
  @observable isToShowPasswordPopup = false
  @observable password = ''
  @observable passwordVisibility = false
  handleClick = () => {
    this.show = true
    this.switchActive = !this.switchActive
  }
  getContent = type => {
    switch (type) {
      case 'FREEZE':
        return {
          title: i18nTranslate(
            'settings.freezeTitle',
            'Are you sure do you want to freeze your account'
          ),
          data: i18nTranslate(
            'settings.freezeData',
            'If you freeze your account, you will need to contact the customer care support to unfreeze your account'
          ),
        }
      case 'DELETE':
        return {
          title: i18nTranslate(
            'settings.deleteTitle',
            'Are you sure do you want to delete your account'
          ),
          data: i18nTranslate(
            'settings.deleteData',
            'On deletion of your account, all your profile, payment, order and subscription details will be removed. Please confirm'
          ),
        }
    }
  }

  renderModal = type => {
    const { title, data } = this.getContent(type)

    return (
      <div>
        <Modal.Header className="border-0 px-0">
          <Modal.Title className="b-title w-75 mx-auto text-center">
            <span className="pr-2">{title}</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="border-0 px-0">
          <Row
            noGutters
            className="flex-column flex-md-row justify-content-center w-75 mx-auto text-center">
            <span>{data}</span>
          </Row>
          <Row noGutters>
            <ButtonGroup className="mx-auto w-50">
              <Button
                onClick={() => {
                  this.switchActive = false
                  this.show = false
                }}
                variant="primary"
                className="d-flex m-2 rounded-0 w-100 justify-content-center">
                {i18nTranslate('settings.noLabel', 'No')}
              </Button>
              <Button
                onClick={() => {
                  this.show = false
                  this.handleDelete(type)
                }}
                variant="outline-primary"
                className="d-flex m-2 rounded-0 w-100 justify-content-center">
                {i18nTranslate('settings.yesLabel', 'Yes')}
              </Button>
            </ButtonGroup>
          </Row>
        </Modal.Body>
      </div>
    )
  }
  handleExport = () => {
    customerContainer.exportPersonalData()
  }

  handleDelete = async type => {
    if (type === 'FREEZE') {
      const response = await customerContainer.updateProfile({
        status: type,
      })
      if (!customerContainer.isSuccessResponse(response)) {
        this.switchActive = !this.switchActive
      }
    } else {
      this.isToShowPasswordPopup = true
    }
  }
  handlePasswordSubmit = async event => {
    event.preventDefault()
    const identity = customerContainer?.profileResponse?.email || ''

    const params = {
      identity,
      password: this.password,
      isToShowToastMessage: false,
    }
    const passwordValidationResponse = await customerContainer.login(params)
    if (customerContainer.isSuccessResponse(passwordValidationResponse)) {
      const response = await customerContainer.deleteCustomer()
      if (!customerContainer.isSuccessResponse(response)) {
        this.isToShowPasswordPopup = !this.isToShowPasswordPopup
        this.switchActive = !this.switchActive
      }
    } else {
      toastState.setToastMessage(
        i18nTranslate('settings.accountFailure', 'Password validation failed'),
        false
      )
    }
  }
  handlePasswordCancel = () => {
    this.switchActive = false
    this.isToShowPasswordPopup = false
  }
  handlePasswordChange = async event => {
    event.persist()
    this.password = event.target.value || ''
  }
  renderPasswordSubmitButton = () => {
    return (
      <Row noGutters className="justify-content-center">
        <Col lg={2} md={2} sm={2} xs={4}>
          <Button onClick={this.handlePasswordSubmit}> Ok </Button>
        </Col>
        <Col lg={2} md={2} sm={2} xs={4}>
          <Button onClick={this.handlePasswordCancel}> Cancel </Button>
        </Col>
      </Row>
    )
  }
  renderPasswordPopup = () => {
    const type = this.passwordVisibility === true ? 'text' : 'password'
    return (
      <Modal show={this.isToShowPasswordPopup}>
        <Modal.Header>
          <Modal.Title>
            {i18nTranslate(
              'settings.passwordTitle',
              'Please enter your password'
            )}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={this.handlePasswordSubmit}>
            <Form.Label>
              {i18nTranslate('settings.passwordLabel', 'Enter Password')}
            </Form.Label>
            <InputGroup className="pb-3">
              <Form.Control type={type} onChange={this.handlePasswordChange} />
              <InputGroup.Append
                className="password-eye-icon-wrapper"
                onClick={() =>
                  (this.passwordVisibility = !this.passwordVisibility)
                }
                data-testid="qa-password-showtext">
                <InputGroup.Text>
                  {this.passwordVisibility ? (
                    <PasswordEyeIconOn
                      aria-label={i18nTranslate(
                        'icons.passwordEyeOn',
                        'password show eye icon',
                        {
                          nameSpace: 'ssr-resource',
                        }
                      )}
                    />
                  ) : (
                    <PasswordEyeIconOff
                      aria-label={i18nTranslate(
                        'icons.passwordEyeOff',
                        'password hide eye icon',
                        {
                          nameSpace: 'ssr-resource',
                        }
                      )}
                    />
                  )}
                </InputGroup.Text>
              </InputGroup.Append>
            </InputGroup>
            {this.renderPasswordSubmitButton()}
          </Form>
        </Modal.Body>
      </Modal>
    )
  }
  renderSubmitButton = () => {
    return (
      <Row>
        <Col lg={6}>
          <Button type="submit"> Ok </Button>
        </Col>
        <Col lg={6}>
          <Button type="submit"> Cancel </Button>
        </Col>
      </Row>
    )
  }
  render() {
    const { data } = this.props
    const myAccountSettingsTitle = i18nTranslate(
      'myAccountSettingsPage.title',
      'Settings | Nu Skin'
    )
    return (
      <>
        <MetaDecorator
          title={myAccountSettingsTitle}
          imageUrl=""
          imageAlt=""
          description="Settings Page"
          location={this.props}
        />
        <Row
          noGutters
          className="justify-content-between border-bottom border-dark p-3 paragraph-m">
          <span>{data.key}</span>
          {data.buttonType === 'Toggle' ? (
            <Button
              variant="light"
              className="switch-icon bg-transparent d-flex border-0 p-0"
              onClick={() => this.handleClick()}>
              {this.switchActive ? (
                <>
                  <ToggleON
                    viewBox={'0 0 35 24'}
                    fill="#0772B4"
                    stroke="#0772B4"
                    className="custom-class-name custom-on"
                  />
                  <span className="my-auto">
                    {i18nTranslate('settings.on', 'ON')}
                  </span>
                </>
              ) : (
                <>
                  <ToggleOff
                    viewBox={'0 0 35 24'}
                    fill="#000"
                    stroke="#000"
                    className="custom-class-name custom-off"
                  />
                  <span className="my-auto">
                    {i18nTranslate('settings.off', 'OFF')}
                  </span>
                </>
              )}
            </Button>
          ) : (
            <Button
              variant="outline-primary"
              className="px-3 export-button"
              onClick={() => this.handleExport()}>
              {data.buttonValue}
            </Button>
          )}
        </Row>
        {data.buttonType === 'Toggle' && (
          <Modal
            size={'lg'}
            show={this.show}
            onHide={() => {
              this.show = false
              this.switchActive = !this.switchActive
            }}>
            {this.renderModal(data.type)}
          </Modal>
        )}
        {this.renderPasswordPopup()}
      </>
    )
  }
}

class Settings extends React.Component {
  renderSwitchIcon = (data, index) => {
    return <SwitchIcon data={data} key={`settings-${index}`} />
  }
  render() {
    return (
      <section className="bg-white">
        <Col className="p-3">
          <h4 className="heading-2">
            {i18nTranslate('myaccount.privacysettingTitle', 'Privacy Settings')}
          </h4>
        </Col>
        <Row noGutters className="flex-column">
          {settingsData.map(this.renderSwitchIcon)}
        </Row>
      </section>
    )
  }
}

export { Settings }

export default Settings
